export default "__VITE_ASSET__DbEuds9M__"